import { useQuery } from '@tanstack/react-query';
import { checkNeedSyncPackageAPI } from '../apis';

const useCheckNeedSyncPackage = ({ appInstanceId }) => {
  const query = useQuery({
    queryKey: ['need-sync-package', appInstanceId],
    queryFn: () => checkNeedSyncPackageAPI({ appInstanceId }),
    staleTime: 0,
  });

  return query;
};

export default useCheckNeedSyncPackage;
